import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LoadingIcon from '../shared/LoadingIcon';
import i18n from '../../config/i18n';

const styles = {
  table: {
    marginTop: 10,
    marginBottom: 10,
  },
  td: {
    seq: {
      width: '5%',
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
    },
    content: {
    },
    center: {
      textAlign: 'center',
      verticalAlign: 'middle',
    },
  },
  email: {
    margin: 0,
  },
  meta: {
    display: 'inline-block',
    verticalAlign: 'top',
    lineHeight: 1.7,
    width: '100%',
    info: {
      display: 'inline-block',
      marginRight: 12,
      verticalAlign: 'middle',
      color: '#7F8994',
    },
    icon: {
      marginRight: '.3em',
      color: '#7F8994',
      fontSize: '.8em',
      verticalAlign: 'text-top',
    },
    text: {},
  },
};

export default class InvitationTable extends Component {
  static propTypes = {
    invitations: PropTypes.arrayOf(PropTypes.shape({
      created: PropTypes.string.isRequired,
    })).isRequired,
    isLoading: PropTypes.bool.isRequired,
    resendInvitation: PropTypes.func.isRequired,
    canResend: PropTypes.bool,
  };

  static defaultProps = {
    canResend: false,
  };

  handleClickResendButton = (event) => {
    this.props.resendInvitation(event.target.getAttribute('data-invitationid'));
  };

  render() {
    const {
      invitations,
      isLoading,
      canResend,
    } = this.props;
    let invitationsBlock;

    if (isLoading) {
      invitationsBlock = (
        <tr style={styles.td.center}>
          <td />
          <td><LoadingIcon /></td>
          <td />
        </tr>
      );
    } else if (_.isEmpty(invitations)) {
      invitationsBlock = (
        <tr style={styles.td.center}>
          <td />
          <td>
            {i18n.t('noInvitationMsg')}
          </td>
          <td />
        </tr>
      );
    } else {
      invitationsBlock = invitations
        .sort((a, b) => Date.parse(b.created) - Date.parse(a.created))
        .map((invitation, index) => (
          <tr key={invitation.id}>
            <td style={styles.td.seq}>
              <h5>{index + 1}</h5>
            </td>
            <td style={styles.td.content}>
              <h4 style={styles.email}>{invitation.email}</h4>
              <div style={styles.meta}>
                <div style={styles.meta.info}>
                  <span
                    className="glyphicon glyphicon-user"
                    style={styles.meta.icon}
                    aria-hidden="true"
                  />
                  <span>
                    {i18n.t('roleAs')}
                    <span
                      style={{ paddingBottom: '0.2em' }}
                      className="label label-info"
                    >
                      {i18n.t(invitation.role)}
                    </span>
                  </span>
                </div>
                <div style={styles.meta.info}>
                  <span
                    className="glyphicon glyphicon-record"
                    style={styles.meta.icon}
                    aria-hidden="true"
                  />
                  <span style={styles.meta.text}>
                    {i18n.t('invitedAt', {
                      invitedDate: moment(invitation.created).format('YYYY/MM/DD HH:mm'),
                    })}
                  </span>
                </div>
                <div style={styles.meta.info}>
                  <span
                    className="glyphicon glyphicon-hourglass"
                    style={styles.meta.icon}
                    aria-hidden="true"
                  />
                  <span style={styles.meta.text}>
                    {i18n.t('expireAt', {
                      expiredDate: moment(invitation.expiresAt).format('YYYY/MM/DD HH:mm'),
                      days: moment(invitation.expiresAt).diff(moment(), 'days'),
                    })}
                  </span>
                </div>
                <div style={styles.meta.info}>
                  <span
                    className="glyphicon glyphicon-briefcase"
                    style={styles.meta.icon}
                    aria-hidden="true"
                  />
                  <span style={styles.meta.text}>
                    {invitation.team && invitation.team.name}
                  </span>
                </div>
              </div>
            </td>
            {
              canResend && (
                <td style={styles.td.seq}>
                  <button
                    className="btn btn-info pull-right"
                    data-invitationid={invitation.id}
                    onClick={this.handleClickResendButton}
                  >
                    {i18n.t('resend')}
                  </button>
                </td>
              )
            }
          </tr>
        ));
    }

    return (
      <table className="table table-hover table-responsive" style={styles.table}>
        <tbody>
          {invitationsBlock}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/team/InvitationTable.js